import React from 'react';
import { NavLink } from 'react-router-dom';

// Since this component is simple and static, there's no parent container for it.
const Navigation = () => {
  const activeStyle = { color: '#2ce286' };
  return (
    <div className="nav-btns-wrapper">
      <NavLink exact to="/create-vizcode" className="nav-btn unselectable" activeStyle={activeStyle}>Create VizCode</NavLink>
      <NavLink exact to="/register" className="nav-btn unselectable" activeStyle={activeStyle}>Register</NavLink>
      <NavLink to="/accounts" className="nav-btn unselectable" activeStyle={activeStyle}>My Accounts</NavLink>
    </div>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation.js